import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
import { getCookie } from "./utils/getCookie";
import { setCookie } from "./utils/setCookie";

/*!
 * Revealing Module Pattern Boilerplate
 * (c) 2017 Chris Ferdinandi, MIT License, https://gomakethings.com
 */
var InnerSpaceModal = (function () {

	'use strict';

	//
	// Variables
	//
  var modal = document.querySelector('.inner-space-sign-up-modal');
  var modalContent = document.querySelector('.inner-space-sign-up-modal__content');
  var closeButton = document.querySelector('.inner-space-sign-up-modal__close-btn');
  var backdrop = document.querySelector('.inner-space-sign-up-modal__backdrop');
  var joinButton = document.querySelector('.inner-space-sign-up-modal__join-link');

	var publicAPIs = {};


	//
	// Methods
	//

	/**
	 * Private methods
	 */
	var closeModal = function () {
		modal.classList.remove('inner-space-sign-up-modal--open');
		enableBodyScroll(modalContent);
	};

	var registerClickHandlers = function () {
    function closeModalAndSetCookie() {
      closeModal();
      setCookie("sign-up-modal-close", 'true', 365);
    }

    backdrop.addEventListener("click", closeModalAndSetCookie);
    closeButton.addEventListener("click", closeModalAndSetCookie);
    joinButton.addEventListener("click", closeModalAndSetCookie);
    joinButton.addEventListener("click", function () {
      window.location.href = this.getAttribute('href');
    });
	};

	var thisHasBeenDisplayed = function () {
		return Boolean(getCookie("sign-up-modal-close"));
	}

	var isInnerSpacePage = function () {
		var pageTemplate = modal.getAttribute('data-page-template');
		var pageTemplate = modal.getAttribute('data-page-template');
		return pageTemplate == "page.inner-space";
	}

	var allowedToOpen = function () { // business logic
		if (isInnerSpacePage()) {
			return false;
		}

		if (thisHasBeenDisplayed()) {
			return false;
		}

		return true;
	}

	/**
	 * Public methods
	 */
	publicAPIs.openModal = function (force = false) {
		if (allowedToOpen() || force) {
			modal.classList.add('inner-space-sign-up-modal--open');
			disableBodyScroll(modalContent);
		}
	};

	/**
	 * Another public method
	 */
	publicAPIs.init = function (options) {
		registerClickHandlers();
	};


	//
	// Return the Public APIs
	//

	return publicAPIs;

})();